import { useBoolVariation } from '@launchdarkly/react-sdk';

export enum FeatureFlag {
  opsDebug = "ops_debug"
}

export enum ReleaseFlag {
  releaseAddNoticePeriodToSettings = "release_add-notice-period-to-settings_20-05-26",
  checkoutDialogV2 = "release_checkout-dialog-v2_11_05_23",
  digitalCollectionReceipt = "release_digital-collection-receipt_03-09-24",
  hxAirportLookup = "release_hx-airport-lookup_23-10-25",
  kmosManualAllocationReleased = "release_manual-kmos-allocation_04-11-24",
  kmosV2 = "release_kmos-v2_17-01-23",
  manageVehicleIssueTypes = "release_manage-vehicle-issue-types-v1_22-11-22",
  moveKmosTimeSlotsSettings = "release_move-kmos-settings_14-11-24",
  reinstateKeyLocationCreation = "release_reinstate-key-location-creation_30-11-22",
  releaseAddGpsCoordinatesToLocation = "release_add-gps-coordinates-to-locations_03-07-2026",
  releaseAddLuggageFieldToBooking = "release_add-luggage-field-to-booking_23-09-25",
  releaseAdditionalCustomizableFields = "release_customizable-vehicle-customer-fields_31-07-24",
  releaseAdditionalExternalReferences = "release_additional-external-references_21-07-25",
  releaseAdditionalTaxRates = "release_additional-tax-rates_30-01-23",
  releaseAddTrackingIdExpressCheckout = "release_add-tracking-id-express-checkout_23-03-26",
  releaseAgencyFlagToUser = "release_agency-flag-to-user_24-02-2026",
  releaseAlertsHookRefactor = "release_alerts-hook-refactor_02-03-26",
  releaseAllowAddingMultipleValetProducts = "release_allow-adding-multiple-valet-products_03-12-25",
  releaseAllowCheckoutFromBlockParking = "release_allow-checkout-from-block-parking_14-09-22",
  releaseAssetTrackingWebhook = "release_asset-tracking-webhook_22-09-25",
  releaseAuditIssueManagement = "release_audit-issue-management_21-10-25",
  releaseAutoCancellationCalendarDays = "release_auto-cancellation-calendar-days_18-08-25",
  releaseAvailableBookingProducts = "release_available-booking-products_26-04-22",
  releaseBookingAdvancedSearch = "release_booking-advanced-search_03-09-25",
  releaseBookingCardIdentifiers = "release_booking-card-identifiers_23-10-26",
  releaseBookingDatepicker = "release_booking-datepicker_20-10-22",
  releaseBookingHeaderPanel = "release_booking-header-panel_09-03-26",
  releaseBookingLastSeenDate = "release_booking-last-seen-date_06-01-26",
  releaseBookingRemarksV2 = "release_booking-remarks-v2_04-12-24",
  releaseBookingScanOptions = "release_booking-scan-options_18-12-24",
  releaseBookingSearchMatchType = "release_advanced-search-partial-match_21-10-25",
  releaseBookingSearchOpenInNewTab = "release_bookings-in-new-tab_21-10-25",
  releaseBookingStatusStuckInPending = "release_booking-status-stuck-in-pending_10-09-26",
  releaseBookingsPageV2 = "release_bookings-page-v2_17-09-26",
  releaseBookingsPageV2LiveUpdates = "release_bookings-page-v2-live-updates_23-09-26",
  releaseBookingsPageV2LiveUpdatesToggle = "release_bookings-page-v2-live-updates-toggle_30-10-26",
  releaseBookingUncancel = "release_booking-uncancel_28-07-26",
  releaseBookingUndoCheckout = "release_booking-undo-checkout_19-09-23",
  releaseBrandName = "release_booking-name-brand-page_22-10-25",
  releaseCalculateBookingDays = "release_calculate-booking-days_22-01-25",
  releaseDefaultBookingDuration = "release_default-booking-duration_06-07-26",
  releaseDriverAvailabilityRulesForAdmins = "release_driver-availability-rules-for-admins_02-11-26",
  releaseDefaultBookingDurationWithMidnight = "release_default-booking-duration-with-midnight_23-07-26",
  releaseCapProductsSoldPerReturnDate = "release_cap-products-sold-per-return-date_01-07-26",
  releaseCarWashLocation = "release_car-wash-location_18-02-25",
  releaseChangeFilterUiVehicleIssues = "release_change_filter_ui_vehicle_issues_19-12-25",
  releaseChangeOrderOfFabMenu = "release_change-order-of-options-of-fab-menu_13-06-25",
  releaseChartIntervalSelector = "release_chart-interval-selector_24-04-25",
  releaseCheckoutDialogCheckedOutCopy = "release_checkout-dialog-checked-out-copy_19-10-26",
  releaseCollectionDeliveryBookingHeaderStatus = "release_collection-delivery-booking-header-status_24-06-26",
  releaseCollectionDeliveryMeetGreet = "release_collection-delivery-meet-greet_20-05-26",
  releaseCollectionDeliveryMeetGreetV2 = "release_collection-delivery-meet-greet-v2_19-08-26",
  releaseCollectionDeliveryPoints = "release_collection-delivery-points_21-10-26",
  releaseMeetGreetBookingCards = "release_meet-greet-booking-cards_16-09-26",
  releaseMeetGreetArrivals = "release_meet-greet-arrivals_08-07-26",
  releaseMeetAndGreetFeaturesSettings = "release_meet-and-greet-features-settings_29-09-26",
  releaseCommentsOnCanceledBookings = "release_add-comment-to-cancelled-booking_20-08-25",
  releaseComplaintImages = "release_complaint-form-photos_17-06-25",
  releaseCompletedProductsFix = "release_completed-products-fix_24-06-26",
  releaseCopyEmailToClipboard = "release_copy-customer-email-field_08-09-25",
  releaseCreateServiceUser = "release_create-service-user_19-03-26",
  releaseServiceUserTokenManagementV2 = "release_service-user-token-management-v2_08-10-26",
  releaseCustomerRemarksBanner = "release_customer-remarks-banner_15-01-25",
  releaseCustomerRemarksAtCheckout = "release_customer_comments_at_checkout_26-11-24",
  releaseDataManagement = "release_portals-data-management_08-10-24",
  releaseDateKeyBox = "release_date-key-box_21-10-24",
  releaseDeferLabelValidation = "release_defer-label-validation_18-02-2026",
  releaseDeleteLocationFromHierarchy = "release_delete-location-from-hierarchy_20-06-24",
  releaseDeLinkCustomerTaxNameAndTaxNumber = "release_delink_tax_name_and_comapny_tax_number_24-01-25",
  releaseDeprecateArchiveStatus = "release_deprecate-archive-status_03-10-22",
  releaseDeprecateShowUserInLocationView = "release_deprecate-show-user-in-location-view_22-12-25",
  releaseDisplayCleanAirCompliance = "release_display-clean-air-compliance_05-10-26",
  releaseDisableVehicleScanToUser = "release_disable-scan-vehicle-to-user_09-07-25",
  releaseDisplayTimeSlot = "release_display-time-slot-on-booking_16-10-24",
  releaseDistanceSetting = "release_distance-setting_31-07-24",
  releaseDownloadAllInspectionImages = "release_download-all-inspection-images_10-01-25",
  releaseDriverAvailabilityCarSpecific = "release_driver-availibility-car-specific_02-03-06",
  releaseDriverShiftTracker = "release_driver-shift-manager_17-11-25",
  releaseDualParkAllocateFab = "release_dual-park-allocate-fab_12-08-25",
  releaseDualParkVehiclesShowingInLocationHierarchy = "release_dual-park-vehicles-showing-in-location-hierarchy_05-02-26",
  releaseDynamicAllocationPreference = "release_dynamic-allocation-preference_20-05-25",
  releaseEarlyCheckInDialog = "release_early-check-in-dialog_26-11-24",
  releaseEditableBookingCard = "release_editable-booking-card_06-10-22",
  releaseExpressCheckoutV2 = "release_enhanced-express-checkout-information_08-08-25",
  releaseExtraAllocatableLocations = "release_extra-manual-allocatable-locations_02-07-25",
  releaseFeatureUpdates = "release_feature-updates_16-10-24",
  releaseFindKey = "release_find-29-07-25",
  releaseFlightRecordOptions = "release_flight-record-options_03-02-26",
  releaseFloatingPointPaymentFix = "release_floating-point-payment-fix_30-07-26",
  releaseHeaderV2 = "release_header-v2_18-09-25",
  releaseHeaderV2MobileNav = "release_header-v2-mobile-nav_05-05-26",
  releaseHelpCentreLinkForHeader = "release_help_centre_link_for_header_17-05-24",
  releaseHideSysAdminUsersList = "release_hide_sys_admin_users_list_19-02-25",
  releaseImproveBookingBrandLogo = "release_improve-booking-brand-logo_05-10-26",
  releaseImproveContactRecordOptions = "release_improve-contact-record-options_10-08-26",
  releaseImproveFlightLookup = "release_improve-flight-lookup_20-08-25",
  releaseImproveKeysScreen = "release_improve-keys-screen_10-02-25",
  releaseImproveUpsellsPerformance = "release_improve-upsells-performance_05-12-25",
  releaseIdentityProviderTenantPicker = "release_identity-provider-tenant-picker_09-07-26",
  releaseIngestDASAllocations = "release_ingest-das-kmos-allocations_10-03-25",
  releaseInspectionZoneViewer = "release_inspection-zone-viewer_02-07-26",
  releaseInvoiceStayDuration = "release_invoice-stay-duration_11-11-25",
  releaseKeyAuditDueCriteria = "release_key-audit-due-criteria_21-11-25",
  releaseKeyAuditDueCriteriaText = "release_key-audit-due-criteria-text_13-04-26",
  releaseKeyAuditReason = "release_key-audit-reason_17-02-26",
  releaseKeyMasterPermission = "release_key-master-permissions-print-location-and-user-label_08-04-25",
  releaseKeyMasterRole = "release_basic-key-master-role_23-12-24",
  releaseKeyMasterTimeSlot = "release_keymaster-timeslot-allocations-screen_28-04-25",
  releaseKeyPositionAudit6342 = "release_key-audit_6342_14-11-24",
  releaseKeyThenLocationScanning = "release_key-then-location-scanning_03-03-25",
  releaseKeyLocationNotShowing = "release_key-location-not-showing_08-05-26",
  releaseKioskLabels = "release_kiosk-labels_03-06-26",
  releaseKmosSegments = "release_kmos_segment_editor-27-06-22",
  releaseLaneAllocationRules = "release_lane-allocation-rules-28-06-22",
  releaseLocationDragAndDrop = "release_lane-hierarchy-ordering_17-06-25",
  releaseLocationHierarchySearchFilter = "release_location-hierarchy-search-filter_07-03-25",
  releaseLocationWebhooks = "release_location-webhooks_16-10-25",
  releaseLocationDisplayAllocatedVehicle = "release_location-display-allocated-vehicles_06-08-25",
  releaseLocationKeyManagementDropdownFix = "release_location-key-management-dropdown-fix_14-07-26",
  releaseLocationMeetAndGreetType = "release_location-meet-and-greet-type_16-06-26",
  releaseLiveFlightData = "release_live-flight-data_21-10-26",
  releaseLiveUpdateGateway = "release_live-update-gateway_13-08-26",
  releaseMakePaymentDescriptionMandatoryForComp = "release_make-payment-description-mandatory-for-comp-28-07-25",
  releaseMarkVehicleMovementAsCorrection = "release_mark-vehicle-movement-as-correction_06-01-26",
  releaseMobileBusCheckout = "release_mobile-bus-checkout-28-07-25",
  releaseMobileBusCheckoutSelfParkOnly = "release_mobile-bus-checkout-self-park-only_15-10-26",
  releaseMobileNumberSupportsAusFormat = "release_mobile-number-supports-aus-format_14-06-25",
  releaseMobileNumberTruncatesFix = "release_mobile-number-trucates-fix_17-06-26",
  releaseMoveKeyVehicleModalIcons = "release_move-key-vehicle-modal-icons_01-05-25",
  releaseMultiAssetLocationMove = "release_multi-asset-location-move_13-07-26",
  releaseNotesForDrivers = "release_notes-for-drivers_01-05-24",
  releaseOpenLinksInNewTabs = "release_open-links-in-new-tabs_13-02-25",
  releaseOpeningAndClosingDateZoneSettings = "reelase_opening-and-closing-date-zone-settings_15-09-26",
  releaseCustomerFacingZoneName = "release_customer-facing-zone-name_19-10-26",
  releaseRenameOutboundReturnFlightSettings = "release_rename-outbound-and-return-time-settings_06-05-26",
  releasePairedJourneys = "release_paired-journeys_05-06-25",
  releasePickupLocation = "release_pickup-location_10-04-2026",
  releasePreBookedPackagePrice = "release_prebooked-package-price_30-07-25",
  releasePreventAmendmentArrivalAndReturnTimes = "release__prevent-amendment-arrival-and-return-times_16-09-26",
  releasePreventKeyMovementToDifferentCarPark = "release_key-scanning-alternate-carpark_17-04-25",
  releasePreventSavingBlankBookingFields = "release_prevent-saving-blank-booking-fields_01-05-25",
  releasePrintBookingDetailsSetting = "release_print-booking-details-setting_17-11-25",
  releasePrintBookingDetailsPermissions = "release_print-booking-details-permissions_26-06-26",
  releaseQATools = "ops_qa-tools",
  releaseRbac = "release_rbac_28-05-24",
  releaseRbacLanePlanningPermissions = "release_rbac-lane-planning-permissions_22-06-26",
  releaseRbacLocationsManagement = "release_rbac-locations-management_10-03-2026",
  releaseRbacPermissionEditingBookingStartAndEndDate = "release_rbac-permission-editing-booking-start-and-end-date_06-10-26",
  releaseRbacPermissionsCheckInOut = "release_rbac-permissions-check-in-out_13-10-25",
  releaseRbacPermissionsDriverShiftTracker = "release_rbac-driver-shift-tracker_03-12-25",
  releaseRbacPermissionsInsights = "release_rbac-permissions-insights_13-10-25",
  releaseRbacPermissionsInsightsCategories = "release_rbac-permissions-insights-categories_26-06-26",
  releaseRbacPermissionsProductPackages = "release_rbac-permissions-products-packages_13-10-25",
  releaseRbacPermissionsSystemAccess = "release_rbac-permissions-for-system-access_13-10-25",
  releaseRbacRoleCannotHaveZeroPermissions = "release_rbac-role-cannot-have-zero-permissions_02-12-25",
  releaseRecordAlertsInBookingHistory = "release_record-alerts-in-booking-history_02-03-23",
  releaseRefactorChartTitle = "release_refactor-chart-titles_11-09-25",
  releaseRemarksShowingMultipleTimes = "release_remarks-showing-multiple-times_03-09-26",
  releaseRemoveEarlyReturn = "release_remove-early-return_14-11-24",
  releaseReports10556 = "release_reports_10556_31-07-25",
  releaseReports8338 = "release_reports_8338_20-08-24",
  releaseReports8630 = "release_reports_8630_15-09-24",
  releaseReports8666 = "release_reports_8666_08-12-24",
  releaseReports8764 = "release_reports_8764_03-10-24",
  releaseReports8839 = "release_reports_8839_31-10-24",
  releaseReports8841 = "release_reports_8841_21-04-25",
  releaseReports9056 = "release_reports_9056_08-12-24",
  releaseReports9066 = "release_reports_9066_09-12-24",
  releaseReports9094 = "release_reports_9094_09-01-25",
  releaseReports9145 = "release_reports_9145_09-01-25",
  releaseReports9354 = "release_reports_9354_23-02-25",
  releaseReportsAnyUserExPD = "release_reports-any-user-expd_18-10-23",
  releaseReportsExPD = "release_reports-expd_26-07-22",
  releaseReportsExPD171 = "release_reports-expd-171_10-12-25",
  releaseRestrictHistoricalData = "release_restrict-historical-data_28-11-2024",
  releaseSalesReceiptTemplateChanges = "release_sales-receipt-template-changes_21-05-25",
  releaseScanLocationToCompleteKeyAudit = "release_scan-location-to-complete-key-audit_20-03-25",
  releaseScanningStaffPassDriverLocation = "release_scanning-staff-pass-driver-location_13-07-26",
  releaseScanningPage = "release_new-scanning-page_19-02-2026",
  releaseScheduledFlightValidator = "release_scheduled-flight-validator_21-10-26",
  releaseSessionInactivityTimeoutDuration = "release_session-inactivity-timeout_08-09-25",
  releaseSettingsDriverAvailability = "release_settings-driver-availability_24_02-26",
  releaseShowAnprOnBookingCard = "release_show-anpr-on-booking-card_15-08-24",
  releaseShowFlightNumberOnReturnCard = "release_show-flight-number-on-return-card_21-10-26",
  releaseShuttleBusPickupRequest = "release_shuttle-bus-pickup-request_11-03-06",
  releaseShuttlePickup = "release_shuttle-pickup_18-02-2026",
  releaseShuttlePickupFieldsAndMappings = "release_shuttle-pickup-fields-and-mappings_24-02-2026",
  releaseShowShuttleBusPickupInBookingHistory = "release_show-shuttlebus-in-booking-history_19-06-26",
  releaseStoreFuelType = "release_store-fuel-type_10-02-25",
  releaseSydneyDualParkAllocation = "release_sydney-dual-park-allocation_06-03-25",
  releaseSyncKmosSegments = "release_sync-kmos-segments-28-10-22",
  releaseTaskAssignmentMarksOnShift = "release_task-assignment-marks-on-shift_04-07-26",
  releaseTelematicsMapNoDataPrompt = "release_telematics-map-no-data-prompt_05-02-26",
  releaseTimeZoneOffset = "release_timezone-offset_23-02-23",
  releaseTrackingIdValidation = "release_tracking-id-validation_18-11-25",
  releaseTruncateVehicleFields = "release_truncate-vehicle-fields_14-04-25",
  releaseUndoCheckIn = "release_undo-check-in_18-02-25",
  releaseUnknownMovement = "release_unknown-movement_16-04-24",
  releaseUserExternalRef = "release_user-external-ref_01-04-26",
  releaseUseParkspaceRates = "release_use-parkspace-rates-for-booking-extension_20-03-25",
  releaseVehicleDetailsInCheckout = "release_enhanced-express-checkout-vehicle_08-10-25",
  releaseVehicleInReturnsBeforeKey = "release_vehicle_in_returns_before_key_23-05-2024",
  releaseVehicleMovementAssumeKeyholder = "release_vehicle-movement-assume-keyholder_19-06-25",
  releaseVipLocation = "release_vip-location_17-04-25",
  releaseWebhookSettingsForSystemAdmins = "release_webhook-settings-for-system-admins_17-11-25",
  releaseWrongOptionsInFabMenu = "release_wrong-option-in-fab-menu_29-07-26",
  releaseWhat3wordsToSettings = "release_what3words-to-settings_06-05-26",
  releaseZoneCheck = "release_zone-check-for-date-box_11-06-25",
  reportExecuteById = "release_report-execute-by-id_04-09-23",
  returnToLocationsListOnSubmit = "release_return-to-locations-list-on-submit_24-02-25",
  templateReportFilename = "release_template-report-filename_16-12-24",
  tenantDataCopy = "release_tenant-data-copy_24-07-25",
  vehicleMoveKmosRules = "release_move-vehicles-kmos-rules_22-07-24",
  vehicleMoveUi = "release_move-vehicles-ui_15-07-24",
  releasePreventInvalidBookingDates = "release_prevent-invalid-booking-dates_10-04-26",
  releaseReportsParkITDomain = "release_reports-parkit-domain_10-08-26",
  releaseReportsExPD1431 = "release_reports-expd-1431_05-11-26"
}
export type Flag = FeatureFlag | ReleaseFlag;

export function useFeatureVariant(key: Flag, fallback: boolean): boolean {
  return useBoolVariation(key, fallback);
}

export function useReleaseManagement(key: ReleaseFlag): boolean {
  return useBoolVariation(key, false);
}
